import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { DomService, LocalStorageService } from 'src/core/services';
import { AuthStore } from 'src/core/stores';
import { LanguageSelectComponent } from '../language-select/language-select.component';
import { UserProfileMenuComponent } from '../user-profile-menu/user-profile-menu.component';

@Component({
  selector: 'core-navbar',
  templateUrl: './navbar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    LanguageSelectComponent,
    NgOptimizedImage,
    UserProfileMenuComponent,
  ],
})
export class NavbarComponent {
  private router = inject(Router);
  private localStorageService = inject(LocalStorageService);
  private domService = inject(DomService);
  readonly authStore = inject(AuthStore);

  isDarkTheme = this.localStorageService.getTheme() === 'dark';

  @Input() loading: boolean | undefined;
  @Input() hasSideBar: boolean | undefined;
  @Output() toggleSideBarEvent = new EventEmitter<void>();
  @Output() editProfileEvent = new EventEmitter<void>();

  onThemeChange(event: Event) {
    this.localStorageService.setTheme(
      (event.target as HTMLInputElement).checked ? 'dark' : 'light',
    );
    this.domService.setHtmlAttribute(
      'data-theme',
      this.localStorageService.getTheme(),
    );
  }

  navigateToHome() {
    this.router.navigate(['/']);
  }

  toggleSidebar() {
    if (this.hasSideBar) {
      this.toggleSideBarEvent.emit();
    }
  }
}
